import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router";

import { signOut } from "../../api/authRequest";

import Brand from "./Brand";
import LanguageSelector from "./LanguageSelector";
import { useTranslation } from "../../i18n/TranslationProvider";

const Header = () => {
    const navigate = useNavigate();
    const { logout, isAuthenticated, userProfile } = useAuth();
    const { t } = useTranslation();

    const handleLogout = async () => {
        try {
            await signOut();
        } catch (err) {
            console.error("Logout failed:", err);
        } finally {
            logout();
            navigate("/");
        }
    };

    return (
        <div className="my-4 flex flex-col items-center gap-2">
            <Brand />
            <LanguageSelector />
            {isAuthenticated && (
                <div className="text-center gap-2 mt-2">
                    <h6 className="font-normal text-lg">
                        {t("header.loggedInAs")}
                    </h6>
                    <h6 className="text-lg">
                        {userProfile?.first_name} {userProfile?.last_name}
                    </h6>
                    <h6
                        className="text-teal-600 cursor-pointer mt-2"
                        onClick={handleLogout}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                handleLogout;
                            }
                        }}
                    >
                        {t("header.logout")}
                    </h6>
                    <h6
                        className="text-teal-600 cursor-pointer mt-2"
                        onClick={() => navigate("/help")}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                navigate("/help");
                            }
                        }}
                    >
                        {t("header.needHelp")}
                    </h6>
                </div>
            )}
        </div>
    );
};

export default Header;